import PaymentHeader from "./components/PaymentHeader/PaymentHeader";
import PaymentMethodList from "./components/PaymentMethodList/PaymentMethodList";
import DiscountCode from "./components/DiscountCode/DiscountCode";
import OrderSummary from "./components/OrderSummary/OrderSummary";
import InvoiceDetails from "./components/InvoiceDetails/InvoiceDetails";
import WalletSection from "./components/WalletSection/WalletSection";
import GatewayList from "./components/GatewayList/GatewayList";
import { PaymentProvider, usePayment, } from "../../../context/PaymentContext";
import "./Step4Payment.css";
import toast from "react-hot-toast";
import CartPreview
  from "./components/CartPreview/CartPreview";

/*
|--------------------------------------------------------------------------
| Provider Wrapper
|--------------------------------------------------------------------------
*/

export default function Step4Payment(props) {

  return (
    <PaymentProvider
      cart={props.cart}
      selectedShipping={
        props.selectedShipping
      }
    >
      <Step4PaymentContent
        {...props}
      />
    </PaymentProvider>
  );
}


/*
|--------------------------------------------------------------------------
| Step 4 Content
|--------------------------------------------------------------------------
*/

function Step4PaymentContent({
  cart,
  selectedAddress,
  selectedShipping,
  comment,
  onBack,
  onNext,
}) {

  const {
    paymentMethod,
    setPaymentMethod,

    gateways,
    selectedGateway,
    selectGateway,
    gatewayLoading,

    wallet,
    walletLoading,

    useWallet,
    toggleWallet,

    couponData,
    couponDiscount,
    walletUsed,

    finalSummary,

    handleCouponApplied,
    removeCoupon,

  } = usePayment();


  /*
  |--------------------------------------------------------------------------
  | Continue
  |--------------------------------------------------------------------------
  */

  const handleContinue = () => {

    if (!selectedAddress?.id) {

      toast.error(
        "لطفاً آدرس تحویل را انتخاب کنید."
      );

      return;
    }



    if (!selectedShipping?.method) {

      toast.error(
        "لطفاً روش ارسال را انتخاب کنید."
      );

      return;
    }



    if (
      finalSummary.payable > 0 &&
      paymentMethod === "online" &&
      !selectedGateway
    ) {

      toast.error(
        "لطفاً درگاه پرداخت را انتخاب کنید."
      );

      return;
    }


    /*
    |--------------------------------------------------------------------------
    | Send payment information to parent
    |--------------------------------------------------------------------------
    |
    | Prices are included for UI/state only.
    | Laravel MUST recalculate them during
    | order creation.
    |
    */

    onNext?.({

      paymentMethod,

      gateway:
        paymentMethod === "online"
          ? selectedGateway?.driver ??
          null
          : null,

      couponId:
        couponData?.coupon?.id ??
        null,

      couponCode:
        couponData?.coupon?.code ??
        null,

      walletUsed,

      useWallet,

      payable:
        finalSummary.payable,

    });

  };

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });


  return (
    <section className="payment-step" dir="rtl" >

      <PaymentHeader />


      <div className="payment-layout">

        <div className="payment-left-column">

          <WalletSection />

          <PaymentMethodList />


          <DiscountCode />

          <CartPreview
            cart={cart}
          />


          <InvoiceDetails
            address={selectedAddress}
            shipping={selectedShipping}
            comment={comment}
            onEditAddress={() => onBack(2)}
            onEditShipping={() => onBack(3)}
          />

        </div>


        {/* ==================================================
                    RIGHT
                ================================================== */}

        <div className="payment-right-column">

          <OrderSummary

            summary={
              finalSummary
            }

          />

        </div>

      </div>


      {/* ======================================================
                NAVIGATION
            ====================================================== */}

      <div className="payment-navigation">


        <button
          type="button"
          className="btn-outline"
          onClick={() =>
            onBack?.()
          }
        >
          مرحله قبل
        </button>


        <button
          type="button"
          className="btn-primary"
          onClick={
            handleContinue
          }
        >

          {
            finalSummary.payable > 0
              ? "ادامه پرداخت"
              : "ثبت سفارش"
          }

        </button>

      </div>

    </section>
  );
}